var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customcheckerboard-color-selector"
  }, [_c('div', {
    ref: "checkerboardFabricCanvasContainer",
    class: ['customcheckerboard-color-selector-body', 'customcheckerboard-main-views-wrapper-body']
  }, [_c('h5', {
    class: ['customcheckerboard-color-selector-title', 'text-center', 'customcheckerboard-main-views-wrapper-title']
  }, [_vm._v(_vm._s(_vm.title))]), _vm.dataLoaded ? _c('checkerboard-fabric-canvas', {
    attrs: {
      "tileConfig": _vm.tileConfig,
      "animateTiles": _vm.currentSelectedColor,
      "animateUsingColor": _vm.animateUsingColor,
      "color1": _vm.color1,
      "color2": _vm.color2,
      "activeColorSelection": true
    },
    on: {
      "input": function input(newColorSelected) {
        return _vm.updateCurrentSelectedColorKey(newColorSelected);
      },
      "canvasLoaded": _vm.canvasLoaded
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "customcheckerboard-color-selector-buttons"
  }, [_c('div', {
    staticClass: "customcheckerboard-color-selector-buttons-container"
  }, [_c('button', {
    class: ['customcheckerboard-color-selector-button', {
      'customcheckerboard-color-selector-button-active': _vm.currentSelectedColor === 'color1'
    }],
    on: {
      "click": function click($event) {
        return _vm.updateCurrentSelectedColorKey('color1');
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardColor1))]), _c('button', {
    class: ['customcheckerboard-color-selector-button', {
      'customcheckerboard-color-selector-button-active': _vm.currentSelectedColor === 'color2'
    }],
    on: {
      "click": function click($event) {
        return _vm.updateCurrentSelectedColorKey('color2');
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardColor2))])])]), _c('checkerboard-color-control', {
    attrs: {
      "isMainApp": _vm.isMainApp,
      "value": _vm.currentSelectedColorValue
    },
    on: {
      "input": function input(newColor) {
        return _vm.setCurrentSelectedColor(newColor);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }